// Types
import { useHandleAuth } from "utils";
import type { MenuType } from "../types"
import { PERMISION } from "security";

/**
 * Ensure env base is usable as an absolute browser URL (so `<a target="_blank">` / PermissionLink work).
 * Missing scheme → `http://` for localhost-style hosts, else `https://`.
 */
function normalizeBaseUrl(raw: string): string {
  const b = raw.replace(/\/+$/, "").trim()
  if (!b) return ""
  if (/^https?:\/\//i.test(b)) return b
  if (b.startsWith("//")) {
    if (typeof window !== "undefined" && window.location?.protocol) {
      return `${window.location.protocol}${b}`
    }
    return `https:${b}`
  }
  const isLocal =
    /^localhost(?::|\b)/i.test(b) ||
    /^127\.0\.0\.1(?::|\b)/.test(b) ||
    /^0\.0\.0\.0(?::|\b)/.test(b)
  return isLocal ? `http://${b}` : `https://${b}`
}

/** Absolute app URL `{base}/{subdomain}/`; `#` if env or subdomain missing (avoids relative `undefined/.../` paths). */
function subscribedAppUrl(
  baseEnv: string | undefined,
  subdomain: string | undefined
): string {
  const base = baseEnv?.trim()
  const sub = subdomain?.trim()
  if (!base || !sub) return "#"
  const root = normalizeBaseUrl(base)
  if (!root) return "#"
  return `${root.replace(/\/+$/, "")}/${sub}/`
}

export const useLogoMenu = () => {
    const { userTokenData } = useHandleAuth()
    const userToken = userTokenData()
    const sub = userToken?.subdomain

  return {
    menu: [
        {
            label: "SHOP POS",
            link: subscribedAppUrl(process.env.REACT_APP_BASE_URL_POS, sub),
            permission: PERMISION.SUBSCRIBED
          },
        {
            label: "MARKETING",
            link: "#",
            permission: PERMISION.SUBSCRIBED
          },
        {
            label: "PRODUCTION",
            link: "#",
            permission: PERMISION.SUBSCRIBED
          },
        {
            label: "PROJECT",
            link: subscribedAppUrl(process.env.REACT_APP_BASE_URL_PROJECT, sub),
            permission: PERMISION.SUBSCRIBED
          },
        {
            label: "WAREHOUSE",
            link: "#",
            permission: PERMISION.SUBSCRIBED
          },
        {
            label: "DISTRIBUTION",
            link: "#",
            permission: PERMISION.SUBSCRIBED
          },
          {
            label: "PAYROLL SYSTEM",
            link: subscribedAppUrl(process.env.REACT_APP_BASE_URL_PAYROLL, sub),
            permission: PERMISION.SUBSCRIBED
          },
          {
            label: "BUSINESS ANALYTICS",
            link: subscribedAppUrl(
              process.env.REACT_APP_BASE_URL_BUSINESS_ANALYTICS,
              sub
            ),
            permission: PERMISION.SUBSCRIBED
          },
      ] as MenuType[]
  }
}